export default __webpack_public_path__ + "static/media/shopping.c0e1dcd0.svg";